/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { order } from '../fn/box-order/order';
import { Order$Params } from '../fn/box-order/order';


/**
 * Box order
 */
@Injectable({ providedIn: 'root' })
export class BoxOrderService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `order()` */
  static readonly OrderPath = '/box-order';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `order()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  order$Response(params: Order$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return order(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `order$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  order(params: Order$Params, context?: HttpContext): Observable<void> {
    return this.order$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
